(() => {
  const initFeatureCardMediaTicker = (section) => {
    if (!section) return;

    const tickers = section.querySelectorAll(".js-feature-card-media-ticker");
    if (tickers.length === 0) return;

    tickers.forEach((tickerEl) => {
      if (tickerEl.swiper) {
        tickerEl.swiper.destroy(true, true);
      }

      const slideEls = tickerEl.querySelectorAll(
        ".feature-card__feature-media-list-item"
      );
      if (slideEls.length < 2) return;

      const isOverBackground = !!tickerEl.closest(
        ".feature-card__feature-media--over-background"
      );

      new Swiper(tickerEl, {
        speed: 12000,
        slidesPerView: "auto",
        spaceBetween: isOverBackground ? 0 : 16,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        watchSlidesProgress: true,
        loop: true,
        loopedSlides: slideEls.length,
        freeMode: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        simulateTouch: false,
        a11y: {
          scrollOnFocus: false,
        },
      });
    });
  };

  const initFeatureCardLinks = (section) => {
    if (!section) return;

    const cards = section.querySelectorAll(".feature-card--has-link");
    cards.forEach((card) => {
      const link = card.querySelector(".feature-card__overlay-link");
      if (!link) return;
      if (card.dataset.cardLinkBound === "true") return;
      card.dataset.cardLinkBound = "true";

      card.addEventListener("click", (event) => {
        // Only react to a primary (left) click.
        if (event.button !== 0) return;

        // Let existing links, buttons and form controls handle their own clicks.
        const interactive = event.target.closest(
          "a, button, .button, input, select, textarea, label, summary, [role='button']"
        );
        if (interactive && interactive !== link) return;

        // Do not navigate while the user is selecting/copying text.
        const selection = window.getSelection();
        if (selection && selection.toString().trim().length > 0) {
          event.preventDefault();
          return;
        }

        // The overlay link handles its own region natively.
        if (event.target.closest(".feature-card__overlay-link")) return;

        // Non-interactive content or media area: follow the card link.
        if (event.metaKey || event.ctrlKey || event.shiftKey) {
          window.open(link.href, "_blank", "noopener");
        } else {
          window.location.href = link.href;
        }
      });
    });
  };

  initFeatureCardMediaTicker(document.currentScript.parentElement);
  initFeatureCardLinks(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initFeatureCardMediaTicker(event.target);
    initFeatureCardLinks(event.target);
  });

  document.addEventListener("shopify:section:reorder", function (event) {
    initFeatureCardMediaTicker(event.target);
    initFeatureCardLinks(event.target);
  });

  document.addEventListener("shopify:block:update", function (event) {
    const section = event.target.closest(".feature-cards-section");
    if (!section) return;
    initFeatureCardMediaTicker(section);
    initFeatureCardLinks(section);
  });
})();
